<template>
  <suggestions
    v-model="query"
    :options="options"
    :onItemSelected="onItemSelected"
    :onInputChange="onInputChange"
  >
    <div slot="item" slot-scope="props" class="single-item">
      <strong>{{props.item.state_name+", "+props.item.name+", "+props.item.post_code}}</strong>
    </div>
  </suggestions>
</template>

<script>
import Suggestions from "v-suggestions";
import "v-suggestions/dist/v-suggestions.css";

export default {
  name: "suburb2",
  components: {
    Suggestions
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      query: "",
      suburb: null,
      suburbs: [],
      options: {},
      searchTimeOut: null,
      searchQuery: ""
    };
  },
  mounted() {},
  methods: {
    onItemSelected(item) {
      this.suburb = item;
      this.query =
        this.suburb.state_name +
        ", " +
        this.suburb.name +
        ", " +
        this.suburb.post_code;
    },
    onInputChange(query) {
      if (query.trim().length === 0) {
        return null;
      }
      const url = "/api/v1/suburb/search?_method=get&keyword=" + query;
      return new Promise(resolve => {
        axios.get(url).then(response => {
          resolve(response.data.data);
        });
      });
    }
  },
  watch: {
    suburb: {
      immediate: true,
      handler() {
        if (this.suburb != null && this.suburb != undefined) {
          this.$emit("input", this.suburb.id);
        }
      }
    },
    value: {
      immediate: true,
      handler() {
        if (
          this.suburb == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;
          self.isLoading = true;
          axios({
            method: "get",
            url: "/api/v1/suburb/search?_method=get&suburb_id=" + self.value
          })
            .then(function(response) {
              self.isLoading = false;
              self.suburb = response.data.data;
              self.query =
                self.suburb.state_name +
                ", " +
                self.suburb.name +
                ", " +
                self.suburb.post_code;
            })
            .catch(function(err) {
              self.isLoading = false;
              self.errors = err.response.data.errors;
            });
		}
		if(this.value == ''){
			this.query = null
		}
      }
    }
  }
};
</script>
